import React, { useEffect, useRef } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledAboutSection = styled.section`
  max-width: 700px;

  .inner {
    display: flex;

    @media (max-width: 600px) {
      display: block;
    }

    // Prevent container from jumping
    @media (min-width: 700px) {
      min-height: 340px;
    }
  }
`;
const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(140px, 200px));
    grid-gap: 0 10px;
    padding: 0;
    margin: 20px 0 0 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      margin-bottom: 10px;
      padding-left: 20px;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '▹';
        position: absolute;
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;
const StyledPic = styled.div`
  position: relative;
  max-width: 300px;

  @media (max-width: 768px) {
    margin: 50px auto 0;
    width: 70%;
  }

  .wrapper {
    ${({ theme }) => theme.mixins.boxShadow};
    display: block;
    position: relative;
    width: 100%;
    border-radius: var(--border-radius);
    background-color: var(--green);

    &:hover,
    &:focus {
      outline: 0;
      transform: translate(-4px, -4px);

      &:after {
        transform: translate(8px, 8px);
      }

      .img {
        filter: none;
        mix-blend-mode: normal;
      }
    }

    .img {
      position: relative;
      border-radius: var(--border-radius);
      mix-blend-mode: multiply;
      filter: grayscale(100%) contrast(1);
      transition: var(--transition);
    }

    &:before,
    &:after {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: var(--border-radius);
      transition: var(--transition);
    }

    &:before {
      top: 0;
      left: 0;
      background-color: var(--navy);
      mix-blend-mode: screen;
    }

    &:after {
      border: 2px solid var(--green);
      top: 14px;
      left: 14px;
      z-index: -1;
    }
  }
`;

const About = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  const skills = ['JavaScript (ES6+)', 'TypeScript', 'React', 'Angular', 'Java', '.Net','Azure Cloud','Go'];

  return (
    <StyledAboutSection id="about" ref={revealContainer}>
      <h2 className="numbered-heading">About Me</h2>

      <div className="inner">
        <StyledText>
          <div>
            <p>
              Hello! My name is Jihed, and I enjoy creating things that live on the internet.
              My interest in web development started back in 2017 when I began editing custom
              Tumblr themes — hacking together a custom reblog button unexpectedly taught me
              a lot about HTML &amp; CSS.
            </p>

            <p>
              Fast-forward to today, I’ve had the opportunity to work with organizations such as{' '}
              <a href="https://www.etap.com.tn/" target="_blank" rel="noreferrer">ETAP</a>,{' '}
              <a href="https://gct.tn/" target="_blank" rel="noreferrer">GCT</a>, and currently{' '}
              <a href="https://viridiengroup.com/" target="_blank" rel="noreferrer">Viridien</a>.
              My main focus today is building a Customer Identity and Access Management (CIAM)
              platform, working on secure authentication flows, role-based access control, and
              scalable web applications for enterprise clients.
            </p>

            <p>
              Outside of work, I enjoy solving cybersecurity challenges and participating in
              Capture The Flag (CTF) competitions on{' '}
              <a href="https://www.root-me.org/barge_ellille" target="_blank" rel="noreferrer">
                Root-Me
              </a>.
            </p>

          
          </div>

        
        </StyledText>


      </div>
    </StyledAboutSection>
  );
};

export default About;
